import {
  getTranslatedText,
  BackgroundIcon,
  AccessControl,
  COMMON_CONSTANTS
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { TextField, Checkbox } from '@superops/ui-design-system';
import TimeUnit from '@nile/mangifera/src/Containers/PageContainers/TimeUnit';
import { WORKLOG_ITEM_STATE } from '@nile/components/src/Constants/worklog';
import { Clock } from '@styled-icons/fa-solid/Clock';
import { MoneyBillAlt } from '@styled-icons/fa-solid/MoneyBillAlt';
import { ShoppingCart } from '@styled-icons/fa-solid/ShoppingCart';
import { Snowflake } from '@styled-icons/fa-solid/Snowflake';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

const ClockIconWrapper = styled.div`
  margin-left: 8px;
`;

const Item = styled.div`
  line-height: 40px;
  margin-right: 20px;
  .quantity {
    margin-left: 8px;
  }
  .quantity .Polaris-TextField {
    max-width: 100px !important;
  }
`;

const IconHolder = styled.div`
  cursor: pointer;
`;

const ItemHolder = styled.div`
  padding: 8px;
  border-radius: 5px;
  &:hover {
    background: #f4f4fc;
  }
`;

function WorklogItemView(props) {
  const { el, intl } = props;
  return (
    <div className="flex">
      <Item className="flex center">
        <SVGIcon name="ServiceCatalog" />
        <div className="ml8">{el.serviceItem.name}</div>
      </Item>
      <AccessControl
        productToCheck={COMMON_CONSTANTS.MSP}
        render={
          <Item className="flex center">
            <SVGIcon name="Billable" />
            <div className="ml8">
              {el.billable
                ? getTranslatedText(intl, 'ticket.details.worklog.tab.billable')
                : getTranslatedText(
                    intl,
                    'ticket.details.worklog.tab.nonbillable'
                  )}
            </div>
          </Item>
        }
      />
      <Item className="flex center">
        {el.serviceItem?.quantityType !== 'UNITS' ? (
          <>
            <SVGIcon name="Worklog" />
            <div className="ml8">{`${el.qty} ${getTranslatedText(
              intl,
              'ticket.details.worklog.unit.hours'
            )}`}</div>
            {el.afterHours ? (
              <div className="flex center">
                <ClockIconWrapper>
                  <SVGIcon name="EstimatedTime" />
                </ClockIconWrapper>
                <div className="ml8 bold">
                  {`${getTranslatedText(
                    intl,
                    'ticket.details.worklog.details.afterHours'
                  )}`}
                </div>
              </div>
            ) : (
              ''
            )}
          </>
        ) : (
          <>
            <SVGIcon name="Quantity" />
            <div className="ml8">{el.qty}</div>
          </>
        )}
      </Item>
    </div>
  );
}

function WorklogItemEdit(props) {
  const {
    el,
    intl,
    handleQuantityChange,
    handleBillableChange,
    updateQuantity,
    updateAfterHours,
    deleteItem
  } = props;
  return (
    <ItemHolder className="flex action-show">
      <Item className="flex center">
        <SVGIcon name="ServiceCatalog" />
        <div className="ml8">{el.serviceItem.name}</div>
      </Item>
      <AccessControl
        roleToCheck="ticketMarkWorklogAsBillable.allow"
        render={
          <Item className="flex center">
            <div className="mr8">
              <Checkbox
                label={getTranslatedText(
                  intl,
                  'ticket.details.worklog.billable'
                )}
                checked={el.billable}
                onChange={handleBillableChange.bind(this, el)}
              />
            </div>
          </Item>
        }
      />

      <Item className="flex center">
        {el.serviceItem?.quantityType !== 'UNITS' ? (
          <>
            <SVGIcon name="Worklog" />
            <TimeUnit el={el} updateQuantity={updateQuantity} />
            <div className="ml8">
              <Checkbox
                label={getTranslatedText(
                  intl,
                  'ticket.details.worklog.afterHours'
                )}
                checked={el.afterHours}
                onChange={updateAfterHours.bind(this, el)}
              />
            </div>
          </>
        ) : (
          <>
            <SVGIcon name="Quantity" />
            <div className="quantity">
              <TextField
                value={el.qty}
                placeholder={getTranslatedText(
                  intl,
                  'ticket.details.worklog.quantity'
                )}
                maxLength={10}
                onChange={handleQuantityChange.bind(this, el)}
                type="number"
              />
            </div>
          </>
        )}
      </Item>
      {el.status === WORKLOG_ITEM_STATE.pending && (
        <IconHolder
          className="ml8 action-visibility flex center"
          onClick={deleteItem.bind(this, el)}
        >
          <SVGIcon name="Delete" />
        </IconHolder>
      )}
    </ItemHolder>
  );
}

export { WorklogItemView, WorklogItemEdit };
